import React, { useContext, useReducer } from "react";

const allReported = React.createContext();

const initialState = {
  allReported: null,
  allReportedStudent: null,
  selectReported: null,
  columnFilter: [],
  notFound: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_REPORTED": {
      console.log("SET_ALL_REPORTED", action.payload);
      return {
        ...state,
        allReported: action.payload,
      };
    }
    case "SET_ALL_REPORTED_STUDENT": {
      return {
        ...state,
        allReportedStudent: action.payload,
        columnFilter: action.payload,
        notFound: false,
      };
    }
    case "SET_SELECT_REPORTED": {
      return {
        ...state,
        selectReported: action.payload,
      };
    }
    case "TEST_LIST_COLUMN_FILTER": {
      console.log("column filter state,query", state, action.query);
      const columnfilter = state.allReportedStudent?.filter((std) => {
        const fullName = `${std.firstname} ${std.lastname}`;

        const reg_fullname = new RegExp(`${action.query.name.toLowerCase()}`);
        const reg_age = new RegExp(`^${action.query.age}`);
        const reg_grade = new RegExp(
          `^${action.query.grade}${action.query.grade !== "" ? "$" : ""}`
        );

        const reg_level = new RegExp(`^${action.query.level}`);

        return (
          !!fullName.toLowerCase().match(reg_fullname) &&
          !!std.age.match(reg_age) &&
          !!std.grade.match(reg_grade) &&
          std.test_date.indexOf(action.query.date) > -1 &&
          !!std.grade_id.match(reg_level)
        );
      });
      console.log("testing", columnfilter);
      if (columnfilter?.length === 0) {
        return {
          ...state,
          columnFilter: columnfilter,
          notFound: true,
        };
      }
      return {
        ...state,
        columnFilter: columnfilter,
        notFound: false,
      };
    }

    default:
      return state;
  }
};

export function AllReportedProvider(props) {
  const [allReportedC, dispatchAllReported] = useReducer(reducer, initialState);
  return (
    <allReported.Provider
      value={{ allReportedC, dispatchAllReported }}
      {...props}
    />
  );
}

export function AllReportedContext() {
  const context = useContext(allReported);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
